import { ReactNode, createContext, useRef } from "react";
import { GeneralObject } from "../types/General";

type CacheApiContextType = {
    cachedData: GeneralObject<unknown>;
    setCache: (key: string, data: unknown) => void;
    getCache: (key: string) => unknown;
}

type CacheApiContextProviderProps = {
    children: ReactNode;
}

const CacheApiContext = createContext<CacheApiContextType | null>(null);

export function CacheApiContextProvider({ children }: CacheApiContextProviderProps) {
    const cachedData = useRef<GeneralObject<unknown>>({});
    
    function setCache(key: string, data: unknown) {
        cachedData.current[key] = data;
    }

    function getCache(key: string) {
        return cachedData.current[key];
    }

    const context = {
        cachedData: cachedData.current,
        setCache,
        getCache
    }

    return (
        <CacheApiContext.Provider value={context}>
            {children}
        </CacheApiContext.Provider>
    )
}

export default CacheApiContext;